import request from '@/utils/request'

let TaskApi = {

  taskList(data, errorback) {
    return request._post('/shop/task.task/index', data, errorback);
  },
  /*添加任务*/
  addTask(data, errorback) {
    return request._post('/shop/task.task/add', data, errorback);
  },
  /*任务详情*/
  toEditTask(data, errorback) {
    return request._get('/shop/task.task/edit', data, errorback);
  },
  /*编辑任务*/
  editTask(data, errorback) {
    return request._post('/shop/task.task/edit', data, errorback);
  },
  /*删除任务*/
  deleteTask(data, errorback) {
    
    return request._post('/shop/task.task/delete', data, errorback);
  },
  /*设置任务*/
  settingTask(data, errorback) {
    return request._post('/shop/task.task/setting', data, errorback);
  },
  /*设置任务*/
  toSettingTask(data, errorback) {
    return request._get('/shop/task.task/setting', data, errorback);
  },
  /*任务打卡列表*/
  clockList(data, errorback) {
    return request._post('/shop/task.clock/index', data, errorback);
  },
  /*添加任务打卡*/
  addClock(data, errorback) {
    return request._post('/shop/task.clock/add', data, errorback);
  },
  /*任务打卡详情*/
  toEditClock(data, errorback) {
    return request._get('/shop/task.clock/edit', data, errorback);
  },
  /*编辑任务打卡*/
  editClock(data, errorback) {
    return request._post('/shop/task.clock/edit', data, errorback);
  },
  /*删除任务打卡*/
  deleteClock(data, errorback) {
    return request._post('/shop/task.clock/delete', data, errorback);
  },
  /*任务排行榜列表*/
  rankList(data, errorback) {
    return request._post('/shop/task.rank/index', data, errorback);
  },
  rankLists(data, errorback) {
    return request._post('/shop/task.rank/list', data, errorback);
  },
}
export default TaskApi;



// WEBPACK FOOTER //
// ./src/api/task.js